// Data.jsx - Oldest to newest. Qualification.jsx reverses this so the most recent role is shown first.

const Data = [
  {
    id: 1,
    category: "experience",
    icon: "icon-briefcase",
    year: "Oct 2021 - Jul 2022",
    title: "SEO Executive",
    sortTitle: "Hafsa Software",
    desc: "Neu Wulmstorf, Germany · Remote"
  },
  {
    id: 2,
    category: "experience",
    icon: "icon-briefcase",
    year: "Aug 2022 - Oct 2022",
    title: "Mid-Level SEO Specialist",
    sortTitle: "Dijitanya SEO & Digital Performance Agency",
    desc: "İstanbul, Türkiye · Remote"
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "Feb 2023 - Jun 2023",
    title: "Java Developer Intern",
    sortTitle: "Politeknik Elektronik",
    desc: "İzmir, Türkiye · On-site"
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "Jan 2023 - Present",
    title: "Software & Web Developer",
    sortTitle: "Freelance",
    desc: "İzmir, Türkiye · Remote"
  },
  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "Mar 2025 - Present",
    title: "Web Developer & Digital Systems Specialist",
    sortTitle: "Censan Endüstriyel Temizlik",
    desc: "İzmir, Türkiye · Hybrid"
  },
];

export default Data;